'use strict';

/**
 * Breadcrumb for SP
 */
module.exports = function () {
    const $bc = $('.m-breadcrumb ol');
    const $bcSp = $('.m-breadcrumbSp');
    if($bc.length) {
        $bc.clone().appendTo($bcSp);
    }
};
